import { render, staticRenderFns } from "./RecoveryPassword.vue?vue&type=template&id=616aefac&scoped=true&"
import script from "./RecoveryPassword.vue?vue&type=script&lang=js&"
export * from "./RecoveryPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616aefac",
  null
  
)

export default component.exports